import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';

import App from "./App";
import "@fontsource/poppins/latin-300.css";
import "@fontsource/poppins/latin-400.css";
import "@fontsource/poppins/latin-400-italic.css";
import "@fontsource/poppins/latin-500.css";
import "@fontsource/poppins/latin-500-italic.css";
import "@fontsource/poppins/latin-600.css";
import "@fontsource/poppins/latin-700.css";
import "@fontsource/poppins/latin-ext-300.css";
import "@fontsource/poppins/latin-ext-400.css";
import "@fontsource/poppins/latin-ext-400-italic.css";
import "@fontsource/poppins/latin-ext-500.css";
import "@fontsource/poppins/latin-ext-500-italic.css";
import "@fontsource/poppins/latin-ext-600.css";
import "@fontsource/poppins/latin-ext-700.css";
import "@fontsource/poppins/devanagari-300.css";
import "@fontsource/poppins/devanagari-400.css";
import "@fontsource/poppins/devanagari-400-italic.css";
import "@fontsource/poppins/devanagari-500.css";
import "@fontsource/poppins/devanagari-500-italic.css";
import "@fontsource/poppins/devanagari-600.css";
import "@fontsource/poppins/devanagari-700.css";
import "@fontsource-variable/noto-sans/wght.css";
import "@fontsource-variable/noto-sans/wght-italic.css";
import "./index.css";
import { store, persistor } from "./app/store";
import { initTestUtils } from "./Utils/testUtils";
import { stripPostmanUtmParams } from "./Utils/utils";

if (process.env.NODE_ENV !== "PRODUCTION") {
  initTestUtils();
}

// Run before anything reads the URL.
stripPostmanUtmParams();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
